import { 
    shift_shift_create,
    shift_list_get,
    shift_id_get,
    shift_shift_update
} from '../../Models/Management/Shift_Model';

//======== CREATE ======
export const onCreateShift = (data) => {
    return new Promise((resolve, reject) => {
        shift_shift_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//====== GET ALL SHIFT =====
export const onGetShift = function (data) {
    return new Promise((resolve, reject) => {
        shift_list_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    })
}

export const onGetShiftById = function (data) {
    return new Promise((resolve, reject) => {
        shift_id_get(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    })
}


//======== EDIT ========
export const onEditShift = (data) => {
    return new Promise((resolve, reject) => {
        shift_shift_update(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: val.status, msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    })
}


